const rooster = {
  checkboxContainer: {
    display: 'flex',
    flex: '0 0 40%',
    justifyContent: 'flex-start',
    alignItems: 'center',
    marginRight: 'auto',
  },
  checkbox: {
    display: 'inline-block',
    width: '100%',
    marginLeft: '10px',
  },
  checkboxLabel: {
    fontWeight: 500,
    fontSize: '0.9em',
    top: '2px', // center vertically just right..
  },
  tooltip: {
    fontSize: '1.4rem',
    opacity: 0.95,
    width: '250px',
    height: 'auto',
    borderRadius: '10px',
    backgroundColor: 'dimgray',
    bottom: '50px',
    padding: '10px',
    position: 'absolute',
    zIndex: 2,
    color: 'white',
  },
}

const tops = {
  checkboxContainer: {
    display: 'flex',
    flex: '0 0 40%',
    justifyContent: 'flex-start',
    alignItems: 'center',
    marginRight: 'auto',
  },
  checkbox: {
    display: 'inline-block',
    width: '100%',
    marginLeft: '10px',
  },
  checkboxLabel: {
    fontWeight: 500,
    fontSize: '0.9em',
    top: '2px', // center vertically just right..
  },
  tooltip: {
    fontSize: '1.4rem',
    opacity: 0.95,
    width: '250px',
    height: 'auto',
    borderRadius: '10px',
    backgroundColor: 'dimgray',
    bottom: '50px',
    padding: '10px',
    position: 'absolute',
    zIndex: 2,
    color: 'white',
  },
}

module.exports = process.env.REACT_APP_IS_TOPS ?
  tops :
  rooster



// WEBPACK FOOTER //
// ./src/components/Settings/styles/ReminderCheckbox.js